import { render, staticRenderFns } from "./input-field.vue?vue&type=template&id=18208a0e&scoped=true&lang=pug"
import script from "./input-field.vue?vue&type=script&lang=js"
export * from "./input-field.vue?vue&type=script&lang=js"
import style0 from "./input-field.vue?vue&type=style&index=0&id=18208a0e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18208a0e",
  null
  
)

export default component.exports